import React, { useState, useEffect } from 'react';
import { MenuItem, FormControl, Select, Card, CardContent } from "@material-ui/core";
import InfoBox from './InfoBox';
import Map from './Map';
import Table from './Table';
import LineGraph from './LineGraph';
import "leaflet/dist/leaflet.css";
import { sortData, prettyPrintStat } from './util';
import './App.css';

function Main() {

    const [countries, setCountries] = useState([]);
    const [country, setCountry] = useState('worldwide');
    const [countryInfo, setCountryInfo] = useState({});
    const [tableData, setTableData] = useState([]);
    const [mapCenter, setMapCenter] = useState({
      lat: 34.80746, lng:-40.4796           //center of Pacific Ocean
    });
    const [mapZoom, setMapZoom] = useState(3);
    const [mapCountries, setMapCountries] = useState([]);
    const [casesType, setCasesType] = useState("cases")
  
    // STATE = Variables in REACT
  
    //https://disease.sh/v3/covid-19/countries
  
    //USEEFFECT = Runs a piece of code based on given condition
  
    useEffect(() => {
      fetch('https://disease.sh/v3/covid-19/all')
      .then((response) => response.json())
      .then((data => {
        setCountryInfo(data);
      }));
    }, [])
    useEffect(() => {
      //The code inside here will run once
      //when the component loads and not again after  
      //async =-> send a reques, wait for it , then do something with it
  
      const getCountriesData = async () => {
        await fetch ("https://disease.sh/v3/covid-19/countries")
        .then((response) => response.json())
        .then((data) => {
          const countries = data.map((country) => (
          {
            name: country.country, //United States, United Kingdom 
            value: country.countryInfo.iso2, // UK, USA
            id: country.countryInfo._id, //4, 35
          }));
          const sortedData = sortData(data);
          setTableData(sortedData);
          setMapCountries(data);
          setCountries(countries);
        })
      };
  
      getCountriesData();
    }, []);
  
    const onCountryChange = async (event) => {
      const countryCode = event.target.value;
  
      const url = countryCode === 'worldwide' ? 'https://disease.sh/v3/covid-19/all' : `https://disease.sh/v3/covid-19/countries/${countryCode}`;
  
      await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setCountry(countryCode); //On dropdown select we are retaining the selected value
        setCountryInfo(data); //All data of the selected country
        setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
        setMapZoom(4);
      })
    };
  
    return (
        <div className="app">
          <div className="app_left">        
            <div className="app_header">
            <h1>COVID-19 TRACKER</h1>
            <FormControl className="app_dropdown"> {/* Using BEM Naming convention (Component name + Element) */}
              <Select variant="outlined" onChange={onCountryChange} value={country}>
                {/* Loop through all the contries and show the dropdown */}
                <MenuItem value="worldwide">Worldwide</MenuItem>
                {
                  countries.map((country, index) => (
                    <MenuItem key={index} value={country.value}>{country.name}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
            </div>
  
            <div className="app_stats">
              <InfoBox
              isRed
              active={casesType === "cases"}
              onClick = {(e) => setCasesType("cases")}
              title="Confirmed" 
              cases={prettyPrintStat(countryInfo.todayCases)} 
              total={prettyPrintStat(countryInfo.cases)}
              />
              <InfoBox 
              isGreen
              active={casesType === "recovered"}
              onClick = {(e) => setCasesType("recovered")} 
              title="Recovered"
              cases={prettyPrintStat(countryInfo.todayRecovered)} 
              total={prettyPrintStat(countryInfo.recovered)}
              />
              <InfoBox 
              isGrey
              active={casesType === "deaths"}
              onClick = {(e) => setCasesType("deaths")} 
              title="Deaths" 
              cases={prettyPrintStat(countryInfo.todayDeaths)} 
              total={prettyPrintStat(countryInfo.deaths)}
              />
            </div>
            <Map casesType={casesType} countries={mapCountries} center={ mapCenter } zoom={ mapZoom }/>
            </div>
            <Card className="app_right">
              <CardContent>
                <h3>Total Cases by Country</h3>
                <Table countries={tableData}/>
                <h3 className="app_graphTitle">Wordwide new {casesType}</h3>
                <LineGraph className="app_graph" casesType={casesType} />
              </CardContent>
            </Card>    
          </div>
    );
  }

export default Main
